import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { AlignedImageWrapperElement, ImageGroupElement } from '../../types';

export const ENHANCED_IMAGE_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'image-group': (node: ImageGroupElement) => {
        const images = (node.images || [])
            .map((img) => `<img src="${escapeHTML(img.src || '')}" alt="${escapeHTML(img.alt || '')}"/>`)
            .join('');
        const caption = node.title ? `<figcaption>${escapeHTML(node.title)}</figcaption>` : '';

        return `<figure class="wrex-content-enhanced-image">${images}${caption}</figure>`;
    },
    'aligned-image-wrapper': (_: AlignedImageWrapperElement, children) =>
        `<div class="wrex-content-aligned-image-wrapper">${children}</div>`,
};
